import { useEffect, useState } from 'react';

export const useScrollToBottom = (ref) => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleScroll = () => {
      const isBottom = 
        Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) <= 2;
      setIsAtBottom(isBottom);
    };

    element.addEventListener('scroll', handleScroll);
    return () => element.removeEventListener('scroll', handleScroll);
  }, [ref.current]);

  return { isAtBottom };
};